import * as React from 'react'
import { Field } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik/MuiTextFieldFormik'

interface Props {
  name: string
  label: string
  testId: string
  required?: boolean
  multiline?: boolean
  maxLength?: number
  /** Forces the error outline, used when the OR-group (name, contact) is unsatisfied. */
  invalid?: boolean
}

/**
 * Labelled text input bound to a Formik field, shared by every plain-text row of the Update
 * Required Fields modal. Shows the field's own error once touched, or the red outline alone when
 * `invalid` is set by a group-level error.
 */
export function RequiredTextField(props: Props) {
  const {
    name,
    label,
    testId,
    required = true,
    multiline,
    maxLength,
    invalid,
  } = props

  return (
    <Field
      name={name}
      label={label}
      component={MuiTextFieldFormik}
      fullWidth
      required={required}
      multiline={multiline}
      minRows={multiline ? 3 : undefined}
      inputProps={maxLength ? { maxLength } : undefined}
      error={invalid}
      data-test-id={testId}
    />
  )
}
RequiredTextField.displayName = 'RequiredTextField'
